"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connection = void 0;
var accounts_1 = require("@near-js/accounts");
Object.defineProperty(exports, "Connection", { enumerable: true, get: function () { return accounts_1.Connection; } });
